import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";
import { CustomerDashboardService } from "src/app/pages/customer-dashboard/services/customer-dashboard.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "fury-feedback-tabs",
  templateUrl: "./feedback-tabs.component.html",
  styleUrls: ["./feedback-tabs.component.scss"],
})
export class feedbackTabsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    "feedback",
    "reviewStatus",
    "assigned",
    'agreementNumber',
    'reviewSubmittedAt',
    'createdBy',
    'priority',
    'request',
    'actions'
  ];
  dataSource = [];
  selectedTabIndex = 0;
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  searchType = "contains";
  @Input() userId = "";
  @Input() editorAccess:boolean;
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  tabMapping = {
    0: "",
    1: "new",
    2: "hold",
    3: "processing",
    4: "completed",
  };
  ngUnsubscribe = new Subject<void>();

  constructor(private apiService: ApiService, private customerDashboardService: CustomerDashboardService) {}

  ngOnInit(): void {
    this.fetchFeedbackDetails();
    this.fetchFeedbackData();
  }
  fetchFeedbackDetails() {
    const tabName =
      this.selectedTabIndex === 0 // 0 means all
        ? ""
        : `&tabName=${this.tabMapping[this.selectedTabIndex]}`;
    this.apiService
      .get(
        `${endpoints.customerDashboard.getFeedbacks(this.userId)}?page=${
          this.pageIndex + 1}&size=${this.pageSize}${tabName}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.dataSource = res.body?.feedbacks?.data;
          this.totalCount = res.body?.feedbacks?.total;
        },
        () => {
          this.dataSource = [];
          this.totalCount = 0;
        }
      );
  }

  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
    this.pageIndex = 0;
    this.totalCount = 0;
    this.fetchFeedbackDetails();
  }
  fetchFeedbackData() {
    this.customerDashboardService.shouldViewFetchFeedback$
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(res =>{
      if(res){
        this.fetchFeedbackDetails();
      }
    })
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchFeedbackDetails();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
